import CollectionProto from "../../data-structures/depricated/collection-proto";
import ViewTemplateBaseModel from "./view-template";

export default class ViewsTemplatesCollection extends CollectionProto<ViewTemplateBaseModel> {

    constructor(models:any) {
        super(models, ViewTemplateBaseModel);
    }
}